module.exports = __webpack_public_path__ + "static/media/Style-Clubs-Serif.4bb24f4b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Style-Clubs-Serif.otf
// module id = 3789
// module chunks = 70